export enum MultileadVersion {
    RP_LIST_OFFER,
    RP_LIST_SAME_OFFER,
    RP_LIST_PROPERTY,
    RP_LIST_VENDOR,
    RP_SWIPE,
    MP_LIST,
    RP_PREMULTILEAD
}
export enum MultileadVersion {
    RP_LIST_OFFER,
    RP_LIST_SAME_OFFER,
    RP_LIST_PROPERTY,
    RP_LIST_VENDOR,
    RP_SWIPE,
    MP_LIST,
    RP_PREMULTILEAD
}
